import { FieldType } from 'features/code-editor/types';
import devPortalConstant from '../constants';

const defaultTooltipValues = {
  isEventGroupOpen: false,
  isEventOpen: false
};

const defaultAppStates = {
  configurations: {
    oauth: {},
    iparams: []
  },
  eventFields: [],
  settings: {
    whitelistedDomains: [],
    dependencies: []
  },
  appValidation: {
    isValidated: false,
    message: '',
    error: ''
  },
  currentApp: {},
  tooltipValues: {
    ...defaultTooltipValues
  }
};

const initialState = {
  userLoggedIn: false,
  userRedirect: false,
  app: {},
  ...defaultAppStates
};

export const rootReducer = (
  state = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case devPortalConstant.SET_LOGGED_IN_USER:
      return { ...state, userLoggedIn: action.payload };
    case devPortalConstant.SET_USER_REDIRECT:
      return { ...state, userRedirect: action.payload };
    case devPortalConstant.SET_WEBHOOK_APP:
      return { ...state, app: action.payload };
    case devPortalConstant.CLEAR_WEBHOOK_APP:
      return { ...state, app: {} };
    case devPortalConstant.SET_OUATH_APP:
      return {
        ...state,
        configurations: { ...state.configurations, oauth: action.payload }
      };
    case devPortalConstant.SET_IPARAM_APP:
      return {
        ...state,
        configurations: { ...state.configurations, iparams: action.payload }
      };
    case devPortalConstant.SET_EVENT_FIELDS:
      return { ...state, eventFields: action.payload };
    case devPortalConstant.SET_WHITELISTED_DOMAINS:
      return {
        ...state,
        settings: { ...state.settings, whitelistedDomains: action.payload }
      };
    case devPortalConstant.SET_DEPENDENCIES:
      return {
        ...state,
        settings: { ...state.settings, dependencies: action.payload }
      };
    case devPortalConstant.UPDATE_SETTINGS:
      return {
        ...state,
        settings: {
          ...state.settings,
          whitelistedDomains: action.payload.whitelistedDomains,
          dependencies: action.payload.dependencies
        }
      };
    case devPortalConstant.SET_APP_VALIDATION:
      return {
        ...state,
        appValidation: {
          isValidated: action.payload.isValidated,
          message: action.payload.message,
          error: action.payload.error
        }
      };
    case devPortalConstant.SET_CURRENT_APP:
      return { ...state, currentApp: action.payload };
    case devPortalConstant.CLEAR_CURRENT_APP:
      return {
        ...state,
        ...defaultAppStates
      };
    case devPortalConstant.SET_TOOLTIP_VALUE:
      return {
        ...state,
        tooltipValues: {
          ...state.tooltipValues,
          [action.payload.property]: action.payload.value
        }
      };
    case devPortalConstant.SET_SIMULATE_CODE:
      return { ...state, eventFields: state.eventFields.map((event: FieldType) => {
        if (event?.field === action.payload.field) {
          return { ...event, simulateCode: action.payload.simulateCode }
        }
        return event;
      }) };
    default:
      return state;
  }
};
